import { CommonUtilities } from '../../commonUtils';
import React, { useEffect, useState } from 'react';
import mechanicalServices from './mechanicalServices';
import DeleteDialogueBox from '../Common/deleteDialogue';
import Svg_icon from 'components/flags/svg_icon';
import Pagination from 'components/Common/newPagination';
import CollectorSelection from './CollectorSelection';

export default function QuarterRun(subEntity: any) {

    const [ISRC, setISRC] = useState("");
    const [Periods, setPeriods] = useState("");
    const [Catalog, setCatalog] = useState("");
    const [ISRCCal, setISRCCal] = useState(false);
    const [Publisher, setPublisher] = useState("");
    const [Collector, setCollector] = useState("");
    const [calcFlag, setcalcFlag] = useState(false);
    const [postmech, setpostmech] = useState(false);
    const [activeZone, setactiveZone] = useState("");
    const [calcAlert, setcalcAlert] = useState(false);
    const [calcFlagTrue, setcalcFlagTrue] = useState(false);
    const [calcISRCtrue, setcalcISRCtrue] = useState(false);
    const [postmechtrue, setpostmechtrue] = useState(false);
    const [suspenseMech, setsuspenseMech] = useState(false);
    const [postmechfalse, setpostmechfalse] = useState(false);
    const [MechCalculate, setMechCalculate] = useState(false);
    const [calcFlagFalse, setcalcFlagFalse] = useState(false);
    const [totalCalculations, settotalCalculations] = useState(0);
    const [PeriodListing, setPeriodListing] = useState<any[]>([]);
    const [AllClientZones, getAllClientZones] = useState<any[]>([]);
    const [exportMessagetrue, setexportMessagetrue] = useState(false)
    const [exportMessagefalse, setcexportMessagefalse] = useState(false);
    const [ConmechanicalList, getConmechanicalList] = useState<any[]>([]);
    const [suspenseInitiationLoading, setsuspenseInitiationLoading] = useState(false);

    const onMechCalculate = (e: any) => {
        console.log(e)
        if (e === 1) {
            if (Periods === '' || activeZone === '') {
                setcalcAlert(true);

                setTimeout(function () {
                    setcalcAlert(false);
                }, 5000);
                return;
            } else {
                mechanicalServices.calculate(Periods, activeZone).then(function (data) {
                    setcalcFlag(true);
                    setTimeout(function () {
                        setcalcFlag(false);
                    }, 5000);
                });
            }

        }
        setMechCalculate(false)
    }

    const onpostmech = (e: any) => {
        console.log(e)
        if (e === 1) {
            console.log("delete")
            mechanicalServices.postMech(Periods, activeZone).then(function (rsp) {

                if (rsp !== null && rsp.result === true) {

                    setpostmechtrue(true)
                    setpostmechfalse(true);

                    setTimeout(function () {
                        setpostmechtrue(false);
                    }, 3000);
                }
                else {
                    setpostmechfalse(true);
                    setpostmechtrue(false)

                    setTimeout(function () {
                        setpostmechfalse(false);
                    }, 3000);

                }

            });
            //ClientProfileSevices.contractStatusdelete(deleteJob.territoryCode).then(()=> { apiCall ();})
        }
        setpostmech(false)
    }

    const onsuspenseMech = (e: any) => {
        console.log(e)
        if (e === 1) {
            console.log("delete")
            mechanicalServices.suspenseInitiation(activeZone, Periods).then(function (url: any) {
                setsuspenseInitiationLoading(true)
                setTimeout(function () {
                    setsuspenseInitiationLoading(false);
                }, 3000);
            });
        }
        setsuspenseMech(false)
    }

    const onISRCCal = (e: any) => {
        console.log(e)
        if (e === 1) {

            if (Collector === '' || ISRC === '') {

                setISRCCal(true);
                setTimeout(function () {
                    setISRCCal(false);
                }, 5000);
            } else {
                mechanicalServices.calcByISRC(Periods, Collector, ISRC).then(() => {

                })
            }

        }
        setISRCCal(false)
    }

    useEffect(() => {
        mechanicalServices.getAllClientZones({ isAllZone: false }).then((value) => {
            getAllClientZones(value);
            if (activeZone.length === 0 && value.length > 0) {
                setactiveZone(value[0].zoneID)
            }
        })

        mechanicalServices.periodCountList().then((value) => {
            setPeriodListing(value);
            for (var $i = 0; $i < value.length; $i++) {
                if (value[$i].periodCurrent === 1) {
                    setPeriods(value[$i].periodDesc);
                }

            }
        })


    }, []);

    var mechPayload = { periodNum: Periods, groupingId: activeZone, pageSize: 10, pageNumber: 1, Publisher: Publisher, Collector: Collector, Catalog: Catalog, ISRC: ISRC };
    const searchMech = () => {
        mechanicalServices.searchMech(mechPayload).then((value) => {
            getConmechanicalList(value);
            settotalCalculations(value && value[0] && value[0].totalRows ? value[0].totalRows : 0)
        })
    };

    const handleNameOnChange = (n: any) => {
        mechPayload.pageNumber = n.pageNumber;
        mechPayload.pageSize = n.pageSize;
        searchMech();
    };

    const calcISRC = () => {

        if (Collector === '' || ISRC === '') {

            setcalcISRCtrue(true);

            setTimeout(function () {
                setcalcISRCtrue(false);
            }, 3000);
        }
        else {
            setISRCCal(true)
        }

    };

    const calcReportISRC = () => {

        if (Collector === '' || ISRC === '') {

            setcalcISRCtrue(true);
            setTimeout(function () {
                setcalcISRCtrue(false);
            }, 5000);
        }
        else {
            var url = 'contracts/mechanical/isrcExportExcel?periodNum=' + Periods + '&collector=' + Collector + '&isrc=' + ISRC;
            CommonUtilities.exportVsWindow(url)
        }

    };

    const suspenseReportInitiation = () => {
        var url = 'contracts/mechanical/suspenseExportExcel?periodNum=' + Periods + '&groupingId=' + activeZone;
        CommonUtilities.exportVsWindow(url)
    };

    const CMRRAExportLicenseRequest = () => {
        var url = 'contracts/mechanical/CMRRALicenseRequest';
        CommonUtilities.exportVsWindow(url);
    };

    const CMRRAExport = () => {
        var url = 'contracts/mechanical/CMRRAExportExcel?periodNum=' + Periods;
        CommonUtilities.exportVsWindow(url);
    };

    const openTxt404 = () => {
        var url = 'contracts/mechanical/AP1Text?periodNum=' + Periods + '&groupingId=' + activeZone;
        CommonUtilities.exportVsWindow(url);
    };

    const openExcel404 = () => {
        var url = 'contracts/mechanical/AP1Excel?periodNum=' + Periods + '&groupingId=' + activeZone;
        CommonUtilities.exportVsWindow(url);
    };

    const QuarterSalesGenerateExport = () => {

        var post = {
            'periodNum': Periods
        };

        mechanicalServices.quarterSalesGenerateExport(post).then(function (rsp: any) {
            if (rsp !== null && rsp === true) {

                setexportMessagetrue(true);
                setcexportMessagefalse(false);

                setTimeout(function () {
                    setexportMessagetrue(false);
                }, 3000);
            }
            else {

                setexportMessagetrue(false);
                setcexportMessagefalse(true);

                setTimeout(function () {
                    setcexportMessagefalse(false);
                }, 3000);

            }
        });
    };

    const HFAExport = () => {
        var url = 'contracts/mechanical/HFAExportExcel?periodNum=' + Periods;
        CommonUtilities.exportVsWindow(url);
    };

    const HFAExportFilter = () => {
        var param = { periodNum: Periods, Publisher: Collector, Collector: Collector, Catalog: Catalog, ISRC: ISRC }
        var url = 'contracts/mechanical/HFAExportFilterExcel?' + CommonUtilities.buildQueryString(param, false, false);
        CommonUtilities.exportVsWindow(url);
    };

    const exportMechanicalCalc = () => {
        var param = { periodNum: Periods, Publisher: Publisher, Collector: Collector, Catalog: Catalog, ISRC: ISRC }
        var pageSize = -1;
        var pageNumber = -1;

        var queryString = CommonUtilities.buildQueryString(param, false, false) ?? "" + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber;

        var url = 'contracts/mechanical/searchMechCalcExportExcel?' + queryString;
        CommonUtilities.exportVsWindow(url);

    }

    const exportByCollector = (all: any) => {
        var param = { periodNum: Periods, Publisher: Collector, Collector: Collector, Catalog: Catalog, ISRC: ISRC, groupingId: all == "all" ? "" : activeZone }

        var queryString = CommonUtilities.buildQueryString(param, false, false) ?? "";
        var url = 'contracts/mechanical/exportByCollector?' + queryString;
        CommonUtilities.exportVsWindow(url);
    };

    const exportMechanical = (all: any) => {
        var param = { periodNum: Periods, groupingId: all == "all" ? "" : activeZone, pageSize: -1, pageNumber: -1, Publisher: Collector, Collector: Collector, Catalog: Catalog, ISRC: ISRC, }

        var queryString = CommonUtilities.buildQueryString(param, false, false) ?? "";
        var url = 'contracts/mechanical/searchMechExportExcel?' + queryString;
        CommonUtilities.exportVsWindow(url);
    };

    const closeModal = (e: any) => {
        //setShowTab(false);
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    let [EditCollectorName, setEditCollectorName] = useState(false)
    let [EditCollectorData, setEditCollectorData] = useState<any[]>([]);
    const openEditCollector = (e: any) => {
        EditCollectorData = e;
        setEditCollectorData(EditCollectorData)
        EditCollectorName = true
        setEditCollectorName(EditCollectorName)
    }

    const onChangeCollectorSelection = (e: any) => {
 
        EditCollectorName = false 
        setEditCollectorName(EditCollectorName)
    }


    return (

        <>
            {(subEntity) && <div id="myModal" className="modal pLarge ws-12 ">


                <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                    <i className="icon-close3 danger"></i>
                </a>

                <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box" style={{ minHeight: "80%" }}>
                    <div className="ws-12 landing">

                        <div className="ws-12 box"> <div className="box-header noBorderRadius bg-blue text-bold"><h2>Quarter Run</h2></div> </div>

                        <div className="12 landing pm ">

                            <div className="ws-12 landing">
                                <ul className="nav nav-tabs mt">

                                    {
                                        AllClientZones?.map((valueList: any) => {
                                            return (
                                                <li className={activeZone == valueList?.zoneID ? "p0 pts pls prs active" : "p0 pts pls prs"} onClick={() => { setactiveZone(valueList?.zoneID); }} >
                                                    <span className="pull-left ms ">{valueList?.zoneID}</span>
                                                    <Svg_icon IName={valueList?.zoneID} />
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>

                            <div className="ws-12 borderRounded pm box">

                                <div className="ws-12 card-title">Mechanical Search </div>

                                <div className="box-content">
                                    <div className="ws-12">
                                        {calcISRCtrue && <div className="alert alert-danger mt" >Please fill Collector & ISRC</div>}
                                        {postmechtrue && <div className="alert alert-info mt">Operation successfully queued for processing</div>}
                                        {postmechfalse && <div className="alert alert-warning mt">Re-run this operation after a few mins as same operation already in progress</div>}

                                        <div className="form-format ws-6">
                                            <label className="control-label ws-3 text-right pr pt" >Periods</label>
                                            <div className="label-entries ws-9">
                                                <select className="form-control" id="period" value={Periods} onChange={(e) => setPeriods(e.target.value)}>

                                                    {
                                                        PeriodListing?.map((value: any) => {
                                                            return (
                                                                <option className={value.periodOpen === 2 ? "btn" : "icon-btn edit opacityDisabled"} value={value.periodDesc}>
                                                                    {CommonUtilities.dateNameFilter(value.periodFrom) + " - " + CommonUtilities.dateNameFilter(value.periodTo)}
                                                                </option>
                                                            )

                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>

                                        <div className="form-format ws-6">
                                            <label className="control-label ws-3 text-right pr pt">Publisher</label>
                                            <div className="label-entries ws-9">
                                                <input type="text" placeholder="Publisher" id="Publisher" value={Publisher} onChange={(e) => setPublisher(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className="form-format ws-6">
                                            <label className="control-label ws-3 text-right pr pt">Collector</label>
                                            <div className="label-entries ws-9">
                                                <input type="text" placeholder="Collector" id="Collector" value={Collector} onChange={(e) => setCollector(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className="form-format ws-6">
                                            <label className="control-label ws-3 text-right pr pt">Catalog</label>
                                            <div className="label-entries ws-9">
                                                <input type="text" placeholder="Catalog" id="Catalogue" value={Catalog} onChange={(e) => setCatalog(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className="form-format ws-6">
                                            <label className="control-label ws-3 text-right pr pt">ISRC</label>
                                            <div className="label-entries ws-9">
                                                <input type="text" placeholder="ISRC" id="ISRC" value={ISRC} onChange={(e) => setISRC(e.target.value)} />
                                            </div>
                                        </div>

                                    </div>

                                    <div className="ws-12 ptl">

                                        <button className="icon-btn edit pull-right" onClick={searchMech}> <i className="icon-search"></i> Search </button>
                                        <button className="btn icon-btn delete pull-right" data-ng-click="clearCalcForm()"> <i className="icon-reload"></i> Reset </button>


                                        <button className="icon-btn edit toolbox pull-left" onClick={() => setMechCalculate(true)}>Calculate </button>
                                        <button className="icon-btn warning pull-left" onClick={() => setpostmech(true)}>Post Mechs </button>
                                        <button className="icon-btn warning pull-left hide">Suspense {suspenseInitiationLoading && <span>- (Push in pending licenses started)</span>}</button>
                                        <button className="icon-btn warning pull-left" onClick={() => setsuspenseMech(true)}>  Suspense {suspenseInitiationLoading && <span ng-show="suspenseInitiationLoading" className="hide">- (Push in pending licenses started)</span>} </button>
                                        <a className="icon-btn info pull-left" onClick={calcISRC}>Calc by ISRC </a>

                                    </div>

                                </div>

                            </div>

                            <div className="ws-12 borderRounded box mt pm landing pbxl mbxl">

                                <div className="ws-12 card-title"> Mechanical Search Result {totalCalculations} record(s) found  </div>

                                <div className="ws-12">
                                    {calcAlert && <div className="ws-12 alert alert-danger" >Please select a period and a region to proceed</div>}
                                    {calcFlagTrue && <div className="ws-12 alert alert-info" >Calculation queued for processing</div>}
                                    {calcFlagFalse && <div className="ws-12 alert alert-warning" >Re-run this operation after a few mins as similar job already in progress</div>}
                                    {totalCalculations === 0 && <div className="ws-12 alert alert-info">No data to display yet</div>}
                                    {exportMessagetrue && <div className="ws-12 alert alert-warning" >Quarter Sales generation has been queued for operation. Check
                                        <a ng-click="openJobStatus()">Job status</a> for progress.
                                    </div>}
                                    {exportMessagefalse && <div className="ws-12 alert alert-warning" >Unable to process Quarter Sales Generation</div>}

                                    <div className="ws-12 allowHscroll allowVscroll box">
                                        {totalCalculations > 0 && <table className="NewTable">
                                            <thead>
                                                <tr>
                                                    <th className='forceSingleLine'>Collector name</th>
                                                    <th className='forceSingleLine'>Publisher</th>
                                                    <th className='forceSingleLine'>Writer</th>
                                                    <th className='forceSingleLine'>Cat log Number</th>
                                                    <th className='forceSingleLine'>ISRC Work Number</th>
                                                    <th className='forceSingleLine'>Perc split</th>
                                                    <th className='forceSingleLine'>Artist</th>
                                                    <th className='forceSingleLine'>Units</th>
                                                    <th className='forceSingleLine'>Formats/Source Codes</th>
                                                    <th className='forceSingleLine'>Penny rate</th>
                                                    <th className='forceSingleLine'>Mech rate</th>
                                                    <th className='forceSingleLine'>Mech amount %</th>
                                                    <th className='forceSingleLine'>Territory Code</th>
                                                    <th className='forceSingleLine'>Track Work Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    ConmechanicalList?.map((value: any) => {
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td>
                                                                        <div className='width90'>
                                                                            <span>{value.collectorName} </span>
                                                                            <button className='icon-btn edit btn-xxs pull-right' onClick={() => openEditCollector(value)}><i className='icon-pencil'></i></button>
                                                                        </div>
                                                                    </td>
                                                                    <td>{value.publisher}</td>
                                                                    <td>{value.writer}</td>
                                                                    <td>{value.catLogNumber}</td>
                                                                    <td>{value.iSrCworkNumber}</td>
                                                                    <td>{value.percSplit}</td>
                                                                    <td>{value.artist}</td>
                                                                    <td>{value.units}</td>
                                                                    <td>{value.format}</td>
                                                                    <td>{value.pennyRate}</td>
                                                                    <td>{value.mechRate}</td>
                                                                    <td>{value.mechAmountPer}</td>
                                                                    <td>{value.territoryCode}</td>
                                                                    <td>{value.trackWorkName}</td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </table>}
                                    </div>

                                    <div className="ws-12 ">
                                        {
                                            (() => {
                                                if (totalCalculations > 1 && totalCalculations > 10) {
                                                    return <div className="pll ml">  <Pagination onPageChange={handleNameOnChange} totalRow={totalCalculations} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>

                                <div className="ws-12 borderRounded box pm mt">

                                    <div className='ws-6 pull-right'>
                                        {(totalCalculations > 0) && <div className="verticalMediumWide hover-box pull-right mtl">
                                            <button className="icon-btn edit"> Export by collector name</button>

                                            <ul className="hover-block mt">
                                                <a className="icon-btn edit btn-xs pull-left mt" onClick={() => exportByCollector(activeZone)}> {activeZone}</a>
                                                <a className="icon-btn edit btn-xs pull-left mt" onClick={() => exportByCollector("all")}>All</a>
                                            </ul>

                                            {(totalCalculations > 5000) && <span className="label label-danger">might take a while</span>}
                                        </div>}

                                        {Periods && <div className="verticalMediumWide hover-box pull-right mtl">
                                            <button className="icon-btn edit"> Report 404</button>
                                            <ul className="hover-block textboxDropdownList">
                                                <a className="icon-btn edit btn-xs pull-left mt" onClick={openTxt404} > TXT</a>
                                                <a className="icon-btn edit btn-xs pull-left mt" onClick={openExcel404}>EXCEL</a>
                                            </ul>
                                        </div>}

                                        {(totalCalculations > 0) && <button className="icon-btn edit hover-box btn pull-right mtl" onClick={exportMechanicalCalc}>
                                            MechCalc Export
                                        </button>}

                                        <div className="verticalMediumWide hover-box pull-right mtl">
                                            <button className="icon-btn edit">Mech Report 401/411</button>
                                            <ul className="hover-block mt" >

                                                <a href={"/CrystalReport/Report401.aspx?template=Reports/401Report.rpt&periodNum=" + Periods} target="_blank"
                                                    className="hover-box icon-btn edit btn-xs pull-left mt">
                                                    <span className={"icon-" + activeZone}>  </span> Report 401 for all zones
                                                </a>

                                                <a href={"/CrystalReport/Report401.aspx?template=Reports/Crystal411.rpt&periodNum=" + Periods} target="_blank"
                                                    className="hover-box icon-btn edit btn-xs pull-left mt">
                                                    <span className={"icon-" + activeZone}></span>Report 411 for all zones
                                                </a>

                                            </ul>
                                        </div>

                                        <a className="icon-btn info btn-xs pull-right mtl hide"> <span className={"icon-US" + activeZone}></span>Report 401 </a>



                                        {(totalCalculations > 0) && <div className="verticalMediumWide hover-box pull-right mtl">
                                            <button className="icon-btn edit"> Export Mechanical</button>

                                            <ul className="hover-block mt">
                                                <a className="icon-btn edit btn-xs pull-left mt" onClick={() => exportMechanical(activeZone)}> {activeZone}</a>
                                                <a className="icon-btn edit btn-xs pull-left mt" onClick={() => exportMechanical("all")}>All</a>
                                            </ul>

                                            {(totalCalculations > 5000) && <span className="label label-danger">might take a while</span>}
                                        </div>}


                                        {Periods && (activeZone === 'UK') && <a className="icon-btn info pull-right mtl"
                                            href={"/CrystalReport/CrystalReport403.aspx?template=Reports/403%20Mechancial%20Summary.rpt&periodNum=" + Periods + "&zone=" + activeZone}
                                            ng-hide="(calc.periodNum && calc.groupingId === 'UK') || true">
                                            <span className={"icon-" + activeZone}></span> Report 403
                                        </a>}

                                        {Periods && (activeZone !== 'UK') && <a target="_blank" href={"/CrystalReport/CrystalReport402.aspx?template=Reports/402%20Publisher%20and%20Collector%20Summary.rpt&periodNum=" + Periods + "&groupingid=" + activeZone}
                                            className="icon-btn edit pull-right mtl">
                                            <span className="icon-US"> </span>Report 402
                                        </a>}
                                    </div>

                                    <div className='ws-6 pull-left'>

                                        <a className="icon-btn edit pull-left mtl" onClick={CMRRAExport}> CMRRA Export </a>

                                        <a className="icon-btn edit pull-left mtl" onClick={CMRRAExportLicenseRequest}> CMRRA License Request  </a>

                                        <div className="verticalMediumWide hover-box pull-left mtl">
                                            <button className="icon-btn edit"> HFA Export</button>
                                            <ul className="hover-block mt" >
                                                <a className="hover-box icon-btn edit btn-xs pull-left mt" onClick={HFAExport}> All </a>
                                                <a className="hover-box icon-btn edit btn-xs pull-left mt forceSingleLine" onClick={HFAExportFilter}> By search criteria </a>
                                            </ul>
                                        </div>

                                        <button className="icon-btn warning pull-left mtl" onClick={suspenseReportInitiation}>
                                            <i className="fa file-excel"></i> Suspense Report <span ng-show="suspenseReportInitiationLoading" className="hide">- (Export Suspense Report started)</span>
                                        </button>

                                        <button className="icon-btn warning pull-left mtl hide" onClick={suspenseReportInitiation}>
                                            <i className="fa file-excel"></i> Suspense Report <span ng-show="suspenseReportInitiationLoading" >- (Export Suspense Report started)</span>
                                        </button>

                                        <button className="icon-btn info pull-left mtl" onClick={calcReportISRC}> <i className="fa file-excel"></i> Calc by ISRC Report   </button>

                                        <div className="verticalMediumWide hover-box mt pull-left mtl">
                                            <a className="icon-btn edit" href={"/CrystalReport/ExportToExcel.aspx?template=QuarterSalesOutput&groupingid=" + activeZone} style={{ color: "white" }}>
                                                Quarter Sales
                                            </a>
                                            <ul className="hover-block mt" >
                                                <a className="hover-box  icon-btn edit btn-xs pull-left" onClick={QuarterSalesGenerateExport} > Generate </a>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                {
                    (() => {

                        if (MechCalculate) {
                            return <DeleteDialogueBox param={true} message={"run the calculation "} onChange={onMechCalculate} />
                        }

                        if (postmech) {
                            return <DeleteDialogueBox param={true} message={"run post mechs "} onChange={onpostmech} />
                        }

                        if (suspenseMech) {
                            return <DeleteDialogueBox param={true} message={"run the suspense "} onChange={onsuspenseMech} />
                        }

                        if (ISRCCal) {
                            return <DeleteDialogueBox param={true} message={"run the calculation by ISRC "} onChange={onISRCCal} />
                        }

                        if (EditCollectorName) {
                            return <CollectorSelection openCollectorSelection={EditCollectorName} EditCollectorData={EditCollectorData} onChangeCollectorSelection={onChangeCollectorSelection} />
                        }
                    })()
                }
            </div>}
        </>
    )
}